import { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { ToolTip } from "../../../AbstractElements";
import { SVGTooltipsTitle } from "../../../Constants/Constants";
import { SVGTooltipsData, SVGTooltipsSubtitle } from "../../../Data/UiKits/Tooltip";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import SvgIcon from "../../CommonComponents/SvgIcon/SvgIcon";

const SVGTooltips = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleTooltip = (index: number) => setOpenIndex(openIndex === index ? null : index);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={SVGTooltipsTitle} span={SVGTooltipsSubtitle} />
        <CardBody className="svg-tooltip light-bg-tooltip">
          <div className="common-flex">
            {SVGTooltipsData &&
              SVGTooltipsData.map((item, index) => (
                <Fragment key={index}>
                  <div className={`bg-light-${item.class}`} id={`svg_${index}`} onClick={() => toggleTooltip(index)}>
                    <SvgIcon className={`stroke-${item.class}`} iconId={item.icon} />
                  </div>
                  <ToolTip isOpen={openIndex === index} target={`svg_${index}`} toggle={() => toggleTooltip(index)}>
                    {item.text}
                  </ToolTip>
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default SVGTooltips;
